import Vue from 'vue'
import VueRouter from 'vue-router'
import { i18n } from "@/plugins/i18n";
Vue.use(VueRouter)

const routes = [
    {
        path: '/:lang',
        component: {
            template: '<router-view></router-view>'
        },
        beforeEnter (to, from, next){
            const lang = to.params.lang
            if (!['en','lo'].includes(lang)) return next('en')
            if (i18n.locale !== lang) {
                i18n.locale = lang
            }
            return next()
        },
        children: []
    }
]

export default new VueRouter({
    routes
})